import { render } from "./OsBasedImageRadioGroup.vue?vue&type=template&id=f4d72150&scoped=true"
import script from "./OsBasedImageRadioGroup.vue?vue&type=script&lang=js"
export * from "./OsBasedImageRadioGroup.vue?vue&type=script&lang=js"

import "./OsBasedImageRadioGroup.vue?vue&type=style&index=0&id=f4d72150&lang=less&scoped=true"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4d72150"]])

export default __exports__